/* eslint-disable camelcase */
import {
    SAVE_CONSIGNMENT_DETAILS_SUCCESS,
    SAVE_CONSIGNMENT_DETAILS_FAILURE,
} from '../actions';

import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { removeEmptyFieldsFromObject } from 'src/utils/util';

export default function* saveConsignment(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/consignment`;
    const payload = removeEmptyFieldsFromObject(action.payload);

    try {
        const result = yield axios
            .post(url, payload)
            .then((response) => response.data);

        const modify_result = {
            ...result,
            isSubmitted: action.payload.isSubmitted,
        };
        yield put({
            type: SAVE_CONSIGNMENT_DETAILS_SUCCESS,
            data: modify_result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SAVE_CONSIGNMENT_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
